/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Winter_Mode_TextInputs */



/**
* | output |
* | --- |
* | "Thermostatic valves and boiler room in normal operation" |
*
* @param {Season_Winter_Mode_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_winter_mode_text = /** @type {((inputs?: Season_Winter_Mode_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Winter_Mode_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermostatic valves and boiler room in normal operation")
	return /** @type {LocalizedString} */ ("Les têtes th. et la chaufferie sont en fonctionnement normal")
});